module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-200.c052e927.eot";